import './Loader.scss';
import { LoaderProps } from './LoaderProps';

export const Loader = (props: LoaderProps) => {

    return <div className="lds-facebook"><div></div><div></div><div></div></div>
}